import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, message, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import { IMG_BASE_URL, RegFormApprovedList } from '../../../AllAPI/AdminAPI'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { useRef } from 'react'
import * as XLSX from 'xlsx'

const RegApprovedList = () => {
  const storedBranchId = sessionStorage.getItem('branch_id')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(false)
  const pdfRef = useRef()

  useEffect(() => {
    fetchRegApprvList()
  }, [])

  const fetchRegApprvList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${RegFormApprovedList}/${storedBranchId}/${BoardingYear}`,
      )


      

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
        tax_id: item.payment?.register_tax_id ?? '-',
        pay_date: item.payment?.register_pay_date?.split('T')[0] ?? '-',
        register_pay_mode:
          item.payment.register_pay_mode == 1
            ? 'Cash'
            : item.payment.register_pay_mode == 2
            ? 'UPI'
            : 'Online',
        payment_img: item.payment?.register_tax_image ?? '',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      message.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    { title: 'Tax ID', dataIndex: 'tax_id' },
    { title: 'Pay Date', dataIndex: 'pay_date' },
    { title: 'Pay Mode', dataIndex: 'register_pay_mode' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  // ======== Print pdf ===========
  const handleDownloadPDF = async () => {
    try {
      setPdfLoading(true)

      const element = pdfRef.current

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
      })

      const imgData = canvas.toDataURL('image/png')

      const pdf = new jsPDF('p', 'mm', 'a4')

      const pageWidth = 210
      const imgWidth = pageWidth
      const imgHeight = (canvas.height * imgWidth) / canvas.width

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)

      pdf.save(`${selectedRecord?.s_fname}_registration.pdf`)
    } catch (err) {
      message.error('Failed to generate PDF')
    } finally {
      setPdfLoading(false)
    }
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      message.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item) => {
      const student = { ...item.full_data }

      // Remove unwanted fields
      delete student.createdAt
      delete student.updatedAt

      // Remove nested timestamps if they exist
      if (student.payment) {
        delete student.payment.createdAt
        delete student.payment.updatedAt
      }

      // Flatten nested objects
      student.payment_mode =
        student.payment?.register_pay_mode === 1
          ? 'Cash'
          : student.payment?.register_pay_mode === 2
          ? 'UPI'
          : 'Online'

      student.tax_id = student.payment?.register_tax_id || ''
      student.pay_date = student.payment?.register_pay_date?.split('T')[0] || ''
      student.pay_amount = student.payment?.register_pay_amount || ''

      // Remove nested object if you don't want it in Excel
      delete student.payment

      const flatStudent = {}

      Object.keys(student).forEach((key) => {
        if (typeof student[key] === 'object' && student[key] !== null) {
          flatStudent[key] = JSON.stringify(student[key])
        } else {
          flatStudent[key] = student[key]
        }
      })

      return flatStudent
    })

    const worksheet = XLSX.utils.json_to_sheet(excelData)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reg Approved')

    XLSX.writeFile(workbook, 'Reg_Approved_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Registration Approved List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => setViewModalOpen(false)}
        footer={[
          <Button key="pdf" onClick={() => setViewModalOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="pdf"
            type="primary"
            loading={pdfLoading}
            onClick={handleDownloadPDF}
          >
            Download PDF
          </Button>,
        ]}
        width={980}
      >
        {selectedRecord && (
          <div ref={pdfRef} className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Registration Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <h6 style={titleText}>- Personal Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-md-4">
                    <span style={labelCss}>Full Name:</span>
                    <br />
                    {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                    {selectedRecord.s_lname}
                  </div>
                  <div className="col-md-4">
                    <span style={labelCss}>Mobile:</span>
                    <br /> {selectedRecord.mobile}
                  </div>
                  <div className="col-md-4">
                    <span style={labelCss}>WhatsApp No:</span>
                    <br /> {selectedRecord.wh_mobile || '-'}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <span style={labelCss}>Email:</span>
                    <br /> {selectedRecord.email}
                  </div>
                  <div className="col-md-8">
                    <span style={labelCss}>Address:</span>
                    <br /> {selectedRecord.address}, {selectedRecord.village}
                  </div>
                </div>
              </div>

              {/* ========= ACADEMIC INFORMATION ========== */}
              <h6 style={titleText}>- Academic Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>Last Attended College:</span>
                    <br /> {selectedRecord.last_attended_clg_name}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>
                      Highest Qualification Obtained:
                    </span>
                    <br /> {selectedRecord.highest_qualification}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>Specific Degree:</span>
                    <br /> {selectedRecord.specific_degree}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>Aggregate Percentage:</span>
                    <br /> {selectedRecord.aggre_percentage}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>Month & Year of Passing:</span>
                    <br /> {selectedRecord.month_year_of_passing}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>
                      Name of Institution Currently Enrolled In:
                    </span>
                    <br /> {selectedRecord.curr_yr_clg_name}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>Course / Program Name:</span>
                    <br /> {selectedRecord.course_name}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>Total Course Duration:</span>
                    <br /> {selectedRecord.total_course_duration}
                  </div>
                  <div className="col-md-6 pt-2">
                    <span style={labelCss}>Remaining Duration of Course:</span>
                    <br /> {selectedRecord.remaining_course_duration}
                  </div>
                </div>
              </div>

              {/* ========= FAMILY INFORMATION ========== */}
              <h6 style={titleText}>- Family Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-md-4">
                    <span style={labelCss}>Father Name:</span>
                    <br />
                    {selectedRecord.father_fname} {selectedRecord.father_mname}{' '}
                    {selectedRecord.father_lname}
                  </div>
                  <div className="col-md-4">
                    <span style={labelCss}>Father Mobile:</span>
                    <br /> {selectedRecord.father_mob}
                  </div>
                  <div className="col-md-4">
                    <span style={labelCss}>Father Occupation:</span>
                    <br /> {selectedRecord.father_occ}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <span style={labelCss}>Father Income:</span>
                    <br /> ₹ {selectedRecord.father_income}
                  </div>
                  <div className="col-md-6">
                    <span style={labelCss}>Total Family Members:</span>
                    <br /> {selectedRecord.total_family_mamber}
                  </div>
                </div>
              </div>

              {/* ========= ADDITIONAL INFORMATION ========== */}
              <h6 style={titleText}>- Additional Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Chairman Name:</span>
                    <br /> {selectedRecord?.chairman_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Chairman Village:</span>
                    <br /> {selectedRecord?.chairman_village}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Chairman Mobile:</span>
                    <br /> {selectedRecord?.chairman_mob}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Reference Name:</span>
                    <br /> {selectedRecord?.reference_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Reference Relation:</span>
                    <br /> {selectedRecord?.reference_relation}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Reference Mobile:</span>
                    <br /> {selectedRecord?.reference_mobile}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Local Guardian Name:</span>
                    <br /> {selectedRecord?.local_guardian_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Local Guardian Address:</span>
                    <br /> {selectedRecord?.local_guardian_address}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Local Guardian Mobile:</span>
                    <br /> {selectedRecord?.local_guardian_mobile}
                  </div>
                </div>
              </div>

              {/* ========= PAYMENT INFORMATION ========== */}
              <h6 style={titleText}>- Payment Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-md-4">
                    <span style={labelCss}>Tax ID:</span>
                    <br /> {selectedRecord.payment?.register_tax_id}
                  </div>
                  <div className="col-md-4">
                    <span style={labelCss}>Payment Date:</span>
                    <br />
                    {selectedRecord.payment?.register_pay_date?.split('T')[0]}
                  </div>
                  <div className="col-md-4">
                    <span style={labelCss}>Amount:</span>
                    <br /> ₹{selectedRecord.payment?.register_pay_amount}
                  </div>
                </div>
              </div>

              {selectedRecord.payment?.register_tax_image && (
                <>
                  <h6 style={titleText}>- Uploaded Payment Proof :</h6>
                  <div
                    className="rounded mb-3 "
                    style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
                  >
                    <img
                      crossOrigin="anonymous"
                      src={`${IMG_BASE_URL}${selectedRecord.payment.register_tax_image}`}
                      alt="Payment"
                      style={{
                        width: '300px',
                        borderRadius: '10px',
                        border: '1px solid #ddd',
                        marginTop: '10px',
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default RegApprovedList
